var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackhat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 714 356.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#332d2f;}.cls-2{fill:#231f20;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.36,85.32s177-192.64,354.64,1Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357,60.32c-197.17,0-357,82.38-357,184,0,42.41,27.85,81.47,74.64,112.59C79,311.46,94,235.17,145.78,189.36c35.58-31.5,73.66-53.92,107.57-65.38h0a184.32,184.32,0,0,1,21.53-5.92c32.92-8,98.77-20,163.19-7.84h0c41.21,5.42,94.76,35.14,142.26,82.64,47.16,47.16,60,117.43,63.1,161.29C687.76,323.49,714,285.48,714,244.32,714,142.7,554.17,60.32,357,60.32Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackhat);
export default __webpack_public_path__ + "static/media/black hat.8cea6ae8.svg";
export { ForwardRef as ReactComponent };